import {BaseFilterModel} from "./baseFilter.model";

export class TerroristFilter extends BaseFilterModel {
  subjectType: string = null; // тип субъекта
  name = ''; // ФИО / наименование организации
  sname = '';
  gname = '';
  pname = '';
  birthDate = ''; // Дата рождения
  inn = ''; // ИНН
  series = ''; // серия документа удост.личность
  number = ''; // номер документа удост.личность
  ogrn = ''; // ОГРН
  idSubject = ''; // Идентификатор записи
}